import React from 'react';
import { Routes, Route } from 'react-router-dom';

import HeroSection from './pages/HeroSection/HeroSection';
import Signup from './pages/Signup/Signup';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import AccountCreated from './pages/AccountCreated/AccountCreated';
import EmailVerified from './pages/EmailVerified/EmailVerified';
import CheckoutPage from './pages/CheckoutPage/CheckoutPage';
import ReturnPage from './pages/ReturnPage/ReturnPage';
import CancelPage from './pages/CancelPage/CanclePage'
import AdminBoard from './pages/AdminBoard/AdminBoard';
import './App.css';

function App() {
  return (
      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/account-created" element={<AccountCreated />} />
        <Route path="/email-verified" element={<EmailVerified />} />
        <Route path="/return" element={<ReturnPage />} />
        <Route path="/checkout/:priceId" element={<CheckoutPage />} />
        <Route path="/cancel" element={<CancelPage/>} />
        <Route path="/admin-board" element={<AdminBoard/>} />
      </Routes>
  );
}

export default App;

